export default __webpack_public_path__ + "static/media/title_sp.f242bb01.png";